import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { Uploader } from './Uploader';
import { Uploaded } from './Uploaded';
import { useFileUpload } from '../../../../hooks';
export const UploadContainer = () => {
    const theme = useTheme();
    const { files, handleFileChange, handleFileRemove } = useFileUpload();
    return (_jsxs(Box, { children: [_jsx(Typography, { fontSize: "12px", letterSpacing: "0.15px", fontWeight: 700, color: theme.palette.text.secondary, children: "Upload Videos:" }), _jsxs(Stack, { gap: "18px", marginTop: "16px", children: [files.length === 0 && _jsx(Uploader, { onFileChange: handleFileChange }), files === null || files === void 0 ? void 0 : files.map((file, index) => (_jsx(Uploaded, { file: file.file, progress: file.progress, status: file.status, onFileRemove: handleFileRemove }, index)))] })] }));
};
